var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"Component",attrs:{"event":_vm.event,"summary":_vm.summary,"data-cy":_vm.cypressAttribute},on:{"delete-comment":comment => _vm.$emit('delete-comment', comment),"restore-comment":comment => _vm.$emit('restore-comment', comment)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }